import { Controller } from '@hotwired/stimulus';
import { post } from '@rails/request.js';

export default class extends Controller {
  static targets = [
    "potentialRecipients",
    "includeListIdentifiers",
    "excludeListIdentifiers",
  ];
  static values = {
    url: String,
  };

  connect() {
    this.fetchPotentialRecipients();
  }

  async fetchPotentialRecipients() {
    this.potentialRecipientsTarget.innerHTML = "Estimating...";

    await post(this.urlValue, {
      responseKind: "turbo-stream",
      body: {
        bulk_message_request: {
          include_list_identifiers: [this.includeListIdentifiersTarget.value],
          exclude_list_identifiers: [this.excludeListIdentifiersTarget.value],
        },
      },
    }).catch((error) => {
      this.potentialRecipientsTarget.innerHTML = "Error estimating recipients";
    });
  }
}
